import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const CheckmarkIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 12.14 9.04",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 9.04),
    ...svgProps,
    fill: color ?? svgProps.fill ?? "currentColor",
    stroke: svgProps.stroke ?? "none",
    children: /*#__PURE__*/jsx("path", {
      d: "M4.34 9.04 0 4.7l1.22-1.22 3.12 3.1L10.92 0l1.22 1.23z"
    })
  });
};

export { CheckmarkIcon };
//# sourceMappingURL=checkmark.js.map
